module.exports = __webpack_public_path__ + "img/futb-01.87fe6add.jpg";